import { render, staticRenderFns } from "./SyncSettings.vue?vue&type=template&id=2bb9223a&"
import script from "./SyncSettings.vue?vue&type=script&lang=js&"
export * from "./SyncSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports